import { render } from "./EventsPage.vue?vue&type=template&id=28cc75aa&scoped=true"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import "./EventsPage.vue?vue&type=style&index=0&id=28cc75aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cc75aa"]])

export default __exports__